import React from 'react';
import { TableRow, TableCell, IconButton } from '@mui/material';
import CustomersFormattedMessages from '../../../../messages/admin/CustomersFormattedMessages';
import { Delete, FileOpen } from '@mui/icons-material';

const AttachmentsTableRow = ({
  customer_id,
  customer_attachment_id,
  created_at = '',
  customer_contact_name = '',
  attachment_name = '',
  status_flag = '',
  updated_at = '',
  onClickDelete = null,
  onClickOpen = null,
  formatDate = null,
}) => (
  <TableRow key={'list' + customer_attachment_id} id={customer_attachment_id}>
    <TableCell name="date">{formatDate(created_at)}</TableCell>
    <TableCell name="name">{customer_contact_name}</TableCell>
    <TableCell name="file">{attachment_name}</TableCell>
    <TableCell name="status">{status_flag}</TableCell>
    <TableCell name="statusDate">{formatDate(updated_at)}</TableCell>
    <TableCell name="controlButtons" align="right">
      <IconButton
        title={CustomersFormattedMessages.open}
        onClick={() => onClickOpen(customer_attachment_id, attachment_name)}
      >
        <FileOpen />
      </IconButton>
      <IconButton
        title={CustomersFormattedMessages.delete}
        onClick={() => onClickDelete(customer_attachment_id)}
        color="error"
      >
        <Delete />
      </IconButton>
    </TableCell>
  </TableRow>
);

export default AttachmentsTableRow;
